import { normalizeSuggestionKeywords } from "@/components/suggestions/providers/utils/normalizeKeywords";
import { INSERT_MATH_KEY } from "@/components/tiptap/tiptap-suggestions/utils";
import { cursorIsActive } from "@/models/CursorModel";

import type { SingleSuggestion, SuggestionProvider } from "@/components/suggestions/types";

export const insertMathSuggestionsProvider: SuggestionProvider = {
  type: "insertMath",
  search: (str, doc) => {
    const { suggestions } = doc.editor;

    if (
      !suggestions.pointerAnchor ||
      str ||
      doc.selection.hasActionableSelection ||
      cursorIsActive(doc.cursor)
    ) {
      return [];
    }

    const insertMath: SingleSuggestion<"group"> = {
      type: "single",
      item: {
        type: "group",
        key: INSERT_MATH_KEY,
        intlName: "insertMath",
        symbol: "",
      },
      keywords: normalizeSuggestionKeywords({ keywords: ["equation", "formula", "expression"] }),
      icon: "InsertMath",
      forceIcon: true,
      popupGroup: "insertMath",
      priority: 1,
    };

    return [[insertMath]];
  },
};
